'use client';

import React from 'react';
import { observer } from 'mobx-react';
import { getStore } from '~/mobx/AppStore';

type Props = {
    isLoggedIn?: boolean;
    loading?: boolean;
    fullName?: string;
    onLogout?: () => void;
};

const ContentRight = (props: Props) => {
    const { fullName, isLoggedIn, loading } = props;

    if (!isLoggedIn || loading) {
        return <></>;
    }

    return (
        <div className="text-[#ccc] mt-[15px]">
            Du er innlogget som <span className="text-[#83ab34]">{fullName}</span>
            <a href="/election-logout" title="Logg ut" className="text-[#ccc] ml-[10px] underline">
                Logg ut
            </a>
        </div>
    );
};

const ContentRightWithStore = () => {
    const { userStore } = getStore();
    const isLoggedIn = userStore.getIsLoggedIn();
    const fullName = userStore.getUserFullName();
    const loading = !userStore.isInitialized || userStore.isLoggingOut;

    return <ContentRight isLoggedIn={isLoggedIn} loading={loading} fullName={fullName} />;
};

export default observer(ContentRightWithStore);
